/**
 * Action types constants for the application
 */
export const actionTypes = {
  // AI Chat actions
  ADD_AI_CHAT_MESSAGE: "ADD_AI_CHAT_MESSAGE",
  SET_AI_CHAT_LOADING: "SET_AI_CHAT_LOADING",
  SET_AI_CHAT_ERROR: "SET_AI_CHAT_ERROR",
  CLEAR_AI_CHAT_ERROR: "CLEAR_AI_CHAT_ERROR",
  CLEAR_AI_CHAT_HISTORY: "CLEAR_AI_CHAT_HISTORY",

  // Additional action types can be added as needed
  GET_MODEL_DATA: "GET_MODEL_DATA",
  SET_MODEL_DATA_LOADING: "SET_MODEL_DATA_LOADING",
};